import { createAction } from 'redux-actions';
import api from '../../services/api';
import {
  SAVE_EMPLOYEE,
  SAVE_EMPLOYEE_SUCCESS,
  SAVE_EMPLOYEE_FAILURE,
  ADD_EMPLOYEE_TO_THE_LIST,
  UPDATE_EMPLOYEE_IN_THE_LIST
} from './actionTypes';
import { change } from 'redux-form';

//<<<---SAVE-EMPLOYEE--->>>
export const saveEmployeeInProgress = createAction(SAVE_EMPLOYEE);
export const saveEmployeeSuccess = createAction(SAVE_EMPLOYEE_SUCCESS);
export const addEmployeeToTheList = createAction(ADD_EMPLOYEE_TO_THE_LIST);
export const saveEmployeeFailure = createAction(SAVE_EMPLOYEE_FAILURE);

export const saveEmployee = (formData, lang, callback) => async dispatch => {
  dispatch(saveEmployeeInProgress());
  try {
    const res = await api.post(`employee/${lang}`, formData);
    const { data } = res;
    callback();
    dispatch(saveEmployeeSuccess(data));
    dispatch(addEmployeeToTheList(data));
  } catch (error) {
    dispatch(saveEmployeeFailure(error));
  }
};

//<<<---UPDATE-EMPLOYEE--->>>
export const updateEmployeeInTheList = createAction(
  UPDATE_EMPLOYEE_IN_THE_LIST
);

export const updateEmployee = (
  formData,
  id,
  lang,
  callback
) => async dispatch => {
  dispatch(saveEmployeeInProgress());
  try {
    const res = await api.post(`employee/${id}/${lang}`, formData, {
      headers: { 'X-HTTP-Method-Override': 'PUT' }
    });
    const { data } = res;
    callback();
    dispatch(saveEmployeeSuccess(data));
    dispatch(updateEmployeeInTheList(data));
  } catch (error) {
    dispatch(saveEmployeeFailure(error));
  }
};

export const setValueToEmptyObject = (formName, fieldName) => () =>
  change(formName, fieldName, {});



// WEBPACK FOOTER //
// ./src/modules/EmployeeForm/actions.js